<template>
	<div class="register">
		<!-- 入会协议-->
		<el-dialog class="dialogNotice" v-if="$store.state.isHouseCampaign" title="优秀住宅" :visible.sync="$store.state.isHouseCampaign" width="70%" v-cloak>
			<div class="notice-title test-1">
				<div class="article">
					<div class="articleTitle">
						<h2>上海市房地产行业协会、房地产开发企业</h2>
						<h2>建设“好房子”倡议承诺书</h2>
					</div>
					<div class="content">
						<p>
							为积极响应国家推进建设好房子的工作要求，在行业内宣传好房子理念、提升好房子技术、提供好房子案例，上海市房地产行业协会组织房地产开发企业努力建设“安全、舒适、绿色、智慧”的好房子，满足人民群众高品质居住需求，积极践行房地产新发展模式，助力房地产市场企稳回升，我们在此发出以下倡议承诺：
						</p>
						<h4>坚持品质至上，让居住安全舒适</h4>
						<p>一是优化户型设计：空间布局合理，使用功能齐全，设施设备完善，提升室内通风、采光、层高，提高私密性和得房率，让每一平方米物尽其用，物有所值，充分体现好户型。</p>
						<p>二是完善配套设施：提升绿化景观，优化交通组织，配置全龄友好休闲娱乐设施，小区商业配套齐全，落实十五分钟社区生活圈。</p>
						<p>三是严格把控质量：建立严格的质量管理体系，做到结构牢固、抗震防灾、建筑本体安全，解决隔音、渗漏、开裂等房屋通病问题，通过智能物联保护老人、小孩在家安全。</p>
						<h4>注重绿色智慧，让居住健康方便</h4>
						<p>一是推进绿色节能：采用绿色节能技术和材料，充分体现节水、节电、节气、节能，为居民降成本、减支出，为社会节能降碳。提升装修标准，实践近零污染精装，提供安全用水设施设备。</p>
						<p>二是应用智能技术：引入智能化家居系统、智能安防系统、智能环境监测与调节设备，打造智慧化居住空间，让房子变得更“聪明”，让居民生活更健康方便。</p>
						<h4>强化客户服务，让居住幸福温馨</h4>
						<p>一是完善售后服务：严格履行房屋销售合同及相关承诺，做到名实相符；严格遵守房屋交付流程，积极主动与业主沟通互动；严格落实商品房竣工验收制度，履行房屋质量保修责任。</p>
						<p>
							二是提升物业水平：维修响应及时，消防安全、绿化养护、垃圾分类、卫生保洁等服务质价相符；利用智能监控系统等现代科技手段提高服务效率；拓展服务范围，支持养老、托育、家政等线上线下的生活服务。
						</p>
						<p>三是丰富社区活动：组织形式多样的便民利民活动、专业技能服务、家庭亲子活动，全面提升居住体验；组织小区居民互动交流，构建和谐邻里关系，营造幸福温馨的居住氛围。</p>
						<p>
							各位同行，谁能向消费者提供好房子谁就能赢得未来的市场。让我们携起手来，以品质为基石，以创新为动力，以责任为担当，共同建设更多的好房子，履行我们对社会、对消费者的倡议和承诺，为推动行业高质量发展贡献我们的力量！
						</p>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remove">取 消</el-button>
				<el-button @click="confirm">报 名</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'HouseCampaign',
	data() {
		return {};
	},
	methods: {
		// 取消
		remove() {
			this.$store.commit('getHouseCampaign', false);
		},
		// 跳转活动评选
		confirm() {
			window.location.href = process.env.VUE_APP_BASE_URL_API + '/nkyxf/nav/px-house-apply-t/my-list';
		},
	},
};
</script>

<style scoped>
:deep(.el-dialog) {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 10px;
	overflow: hidden;
}

:deep(.el-dialog__header) {
	padding: 20px;
	width: 100%;
	text-align: center;
	font-weight: 600;
	background-color: #f2f2f2;
}

:deep(.el-dialog__body) {
	padding: 30px;
	width: 100%;
}

.notice-title {
	width: 100%;
	height: 60vh;
	font-size: 14px;
	line-height: 38px;
	text-align: left;
	overflow: hidden;
	overflow-y: scroll;
}

/* .notice-title p {
    margin-bottom: 12px;
    font-size: 1em;
    letter-spacing: 1px;
    line-height: 32px;
    word-break: break-word;
    overflow-wrap: break-word;
} */

.article .articleTitle {
	margin-bottom: 20px;
}

.test-1::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}

.test-1::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
	background: var(--bg-color-4);
}

.test-1::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	background: #f2f2f2;
}

.note-frame {
	width: 100%;
	border: none;
	height: 100%;
}
:deep(.el-dialog__footer) {
	padding: 0px 20px 20px;
	width: 100%;
}
.dialog-footer {
	display: inline-block;
	width: 100%;
	text-align: center;
}
.dialog-footer .el-button {
	width: 30%;
	background-color: var(--bg-color);
	border-color: var(--bg-color);
	color: #fff;
	-webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-moz-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-ms-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	-o-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
	transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.dialog-footer .el-button:hover {
	background-color: var(--bg-color-8);
	border: 1px solid var(--bg-color-8);
	color: var(--text-light-color);
}
.dialog-footer .el-button:first-child {
	margin-right: 12%;
	background-color: #fff;
	border: 1px solid #dcdfe6;
	color: #606266;
}
.dialog-footer .el-button:first-child:hover {
	background-color: var(--bg-color);
	color: var(--text-light-color);
}
</style>
